var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFacemaxinegative({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 540,
    height: 600,
    viewBox: "0 0 540 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "face_maxi_negative_svg__c",
    d: "M.69 147.504V87.982C.69 39.669 12.999.504 28.19.504c15.188 0 27.5 39.194 27.5 87.504v59.496"
  }), /*#__PURE__*/React.createElement("path", {
    id: "face_maxi_negative_svg__e",
    d: "M0 131.894C0 59.051 59.056 0 131.895 0 204.739 0 263.79 59.044 263.79 131.894v63.565c0 72.844-58.883 136.317-131.517 141.771l-.378.028-.378-.028C58.882 331.775 0 268.31 0 195.46v-63.566z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "face_maxi_negative_svg__g",
    d: "M147.704 136.444c70.728-.14 141.157 38.398 141.157 38.398S316.304 29.296 146.797 0C-29.554 25.66 2.532 174.842 2.532 174.842s73.84-38.256 145.172-38.398z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "face_maxi_negative_svg__i",
    d: "M5.79 8.929c5.626-5.163 30.706-17.207 57.343 0-29.68 7.347-47.472 2.292-57.343 0z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "face_maxi_negative_svg__a",
    width: 412,
    height: 602,
    x: 64,
    y: -1
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "face_maxi_negative_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#face_maxi_negative_svg__a"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#face_maxi_negative_svg__b)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(98.647 28.775)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#A16374",
    stroke: "#363A4F",
    strokeWidth: 11,
    d: "M319.722 140.849l-11.503 258H27.888l-11.503-258h303.337z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 169.155,
    cy: 154.051,
    fill: "#886653",
    stroke: "#363A4F",
    strokeWidth: 11,
    rx: 154.722,
    ry: 158.451
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 299.398,
    cy: 216.873,
    fill: "#FBDCCE",
    stroke: "#363A50",
    strokeWidth: 8.91,
    rx: 36.055,
    ry: 36.07
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 312.319,
    cy: 236.028,
    fill: "#363A50",
    rx: 6.057,
    ry: 6.052
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 40.51,
    cy: 214.892,
    fill: "#FBDCCE",
    stroke: "#363A50",
    strokeWidth: 8.91,
    rx: 36.055,
    ry: 36.07
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 33.038,
    cy: 215.08,
    fill: "#000",
    fillOpacity: 0.1,
    rx: 15.418,
    ry: 15.405
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(146.662 253.72)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "face_maxi_negative_svg__d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#face_maxi_negative_svg__c"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#F9CCB6",
    stroke: "#363A50",
    strokeWidth: 13.86,
    xlinkHref: "#face_maxi_negative_svg__c"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F8CCB8",
    d: "M9.509 85.504s5.394 62 18.88 93.393c13.488 31.393-5.962 30.594-5.962 30.594l-40.743-54.747-.994-59.578 28.819-9.662z",
    mask: "url(#face_maxi_negative_svg__d)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(37.998 18.024)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "face_maxi_negative_svg__f",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#face_maxi_negative_svg__e"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#F9CCB6",
    xlinkHref: "#face_maxi_negative_svg__e"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FBDCCE",
    stroke: "#363A50",
    strokeWidth: 11,
    d: "M131.917 5.5c34.895.006 66.486 14.151 89.354 37.02 22.873 22.871 37.019 54.47 37.019 89.374h0v63.565c0 35.013-14.179 67.758-37.053 92.416-22.784 24.56-54.217 41.119-88.969 43.839-35.077-2.718-66.668-19.236-89.544-43.754C19.71 263.295 5.5 230.515 5.5 195.46h0v-63.566c0-34.524 13.843-65.815 36.28-88.626C64.25 20.423 95.342 6.082 129.78 5.518h0z",
    mask: "url(#face_maxi_negative_svg__f)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#363A50",
    fillOpacity: 0.1,
    d: "M237.402 126.006s53.054 157.453-90.68 212.008c-143.734 54.554 127.922-24.657 127.922-24.657L374.69 73.92l-128.97 42.375-8.32 9.71z",
    mask: "url(#face_maxi_negative_svg__f)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(24.009)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "face_maxi_negative_svg__h",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#face_maxi_negative_svg__g"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#363A4F",
    strokeWidth: 8.8,
    d: "M146.876-4.45l.67.114C322.18 25.846 293.186 175.657 293.186 175.657l-.018.09-.023.11c-.127.616-.564 2.635-1.424 5.728a189.004 189.004 0 00-4.66-2.71l-.136-.076a35.573 35.573 0 00-.175-.097s-69.362-37.996-139.036-37.858c-70.351.14-143.157 37.905-143.157 37.905s-1.78.923-4.938 2.696c-.846-3.098-1.275-5.119-1.399-5.729-.816-4.027-13.345-69.964 29.419-121.792C49.525 27.398 85.913 4.412 146.164-4.354c.228-.033.456-.066.712-.097z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A16374",
    stroke: "#363A4F",
    strokeWidth: 8.8,
    d: "M146.876-4.45l.67.114C322.18 25.846 293.186 175.657 293.186 175.657l-.018.09-.023.11c-.127.616-.564 2.635-1.424 5.728a189.004 189.004 0 00-4.66-2.71l-.136-.076a35.573 35.573 0 00-.175-.097s-69.362-37.996-139.036-37.858c-70.351.14-143.157 37.905-143.157 37.905s-1.78.923-4.938 2.696c-.846-3.098-1.275-5.119-1.399-5.729-.816-4.027-13.345-69.964 29.419-121.792C49.525 27.398 85.913 4.412 146.164-4.354c.228-.033.456-.066.712-.097z",
    mask: "url(#face_maxi_negative_svg__h)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#363A50",
    fillOpacity: 0.2,
    d: "M165.326-9.775S267.287 62.569 267.287 92.967c0 30.398-218.601-46.187-271.234 85.04-52.633 131.226 43.86 46.023 43.86 46.023l320.124-22.149 20.14-141.57-127.14-66-87.71-4.086z",
    mask: "url(#face_maxi_negative_svg__h)"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#363A50",
    strokeLinecap: "round",
    strokeWidth: 6.732,
    d: "M271.094 159.856c-6.895-11.942-25.925-13.863-42.504-4.29"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#363A50",
    strokeLinecap: "round",
    strokeWidth: 5.742,
    d: "M79.033 156.884c6.894-11.942 25.924-13.863 42.504-4.29"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#363A50",
    strokeLinecap: "round",
    strokeWidth: 4.657,
    d: "M165.945 238.14s-4.476 20.461.319 25.092c4.795 4.63 17.052-.284 17.052-.284"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#363A50",
    strokeLinecap: "round",
    strokeWidth: 4.851,
    d: "M22.487 211.172c5.91-3.551 13.578-1.64 17.128 4.267h0c3.55 5.907 1.636 13.575-4.274 17.126M301.453 203.426c5.203-4.523 13.087-3.974 17.608 1.228h0c4.522 5.201 3.97 13.085-1.234 17.608"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.1,
    d: "M165.75 235.072s-2.074 23.06 19.87 27.462l-16.6 2.2-4.406-6.601 1.136-23.06z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 243.281,
    cy: 185.492,
    fill: "#FFF",
    rx: 19.324,
    ry: 19.314
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 96.619,
    cy: 185.492,
    fill: "#FFF",
    rx: 19.324,
    ry: 19.314
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 242.815,
    cy: 185.678,
    fill: "#363A50",
    rx: 10.462,
    ry: 10.453
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 96.815,
    cy: 185.678,
    fill: "#363A50",
    rx: 10.462,
    ry: 10.453
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#363A50",
    points: "133.722 140.914 142.997 48.587 148.925 140.819"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#363A50",
    points: "223.667 145.248 230.386 80.327 234.68 145.182"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#363A50",
    points: "79.401 154.051 86.12 89.13 90.414 153.985"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(137.9 282.446)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#F5BBAC",
    strokeLinecap: "round",
    strokeWidth: 2.954,
    d: "M.385 5.258C-.162 5.51-.12 7.406.476 9.49h0c.598 2.086 1.526 3.571 2.073 3.318M68.946 5.245c.582 0 1.054 1.798 1.054 4.017h0c0 2.22-.472 4.018-1.054 4.018"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "face_maxi_negative_svg__j",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#face_maxi_negative_svg__i"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#E68794",
    xlinkHref: "#face_maxi_negative_svg__i"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.1,
    d: "M5.287 8.893s10.415-3.99 28.166-3.776c17.75.214 35.19 5.186 35.19 5.186l-43.725-22.9L5.287 8.893z",
    mask: "url(#face_maxi_negative_svg__j)"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 28,
    x: 147.353,
    y: 359.92,
    fill: "#FBDCCE"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.1,
    d: "M149.786 352.73s54.01 7.702 54.01 20.906l3.303-27.509-57.313 6.603z"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#363A50",
    strokeLinecap: "round",
    strokeWidth: 8,
    d: "M415 267c3.715 0 7.091 1.757 9.598 4.623 2.71 3.1 4.402 7.499 4.402 12.377 0 9.389-6.268 17-14 17s-14-7.611-14-17c0-1.852.244-3.635.695-5.305"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#363A50",
    strokeLinecap: "round",
    strokeWidth: 5,
    d: "M278 284c1.857 0 3.546.878 4.799 2.312 1.355 1.55 2.201 3.749 2.201 6.188 0 4.694-3.134 8.5-7 8.5-2.828 0-5.265-2.037-6.37-4.969a9.539 9.539 0 01-.193-.567"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacemaxinegative);
export default __webpack_public_path__ + "static/media/face.maxi.negative.1ed673fe.svg";
export { ForwardRef as ReactComponent };